module.exports = __webpack_public_path__ + "static/media/bkWallDinein.3ce79883.svg";